import React from 'react';

const Btn = (props) => {
  let handleClick = props.handleClick;
  let hasIcon = false;
  let hasTitle = false;
  let cl = 'btn';
  let jsxTitle = null;
  let jsxFontAwsome = null;
  if (props.inline) {
    cl += ' btn--inline';
  }
  if (props.disabled === true) {
    cl += ' btn--disabled';
    handleClick = () => { };
  }
  if (props.outline === true) {
    cl += ' btn--outline';
  }
  if (props.circle) {
    cl += ' btn--circle'
  }
  if (props.color) {
    let color = props.color;
    cl += ' ' + color;
  }
  if (props.extraClass) {
    cl += ' ' + props.extraClass;
  }
  if (typeof props.title === 'string' && props.title !== '') {
    hasTitle = true;
    jsxTitle = (
      <span>{props.title}</span>
    );
  }
  if (typeof props.i === 'string' && props.i !== '') {
    hasIcon = true;
    jsxFontAwsome = (
      <i className={props.i} aria-hidden="true"></i>
    );
  }

  if (props.btnDialogCancel) {
    cl += ' btn--dialog-cancel';
  }
  if (props.btnDialogSubmit) {
    cl += ' btn--dialog-submit';
  }

  if (props.btnSmallWithTitle) {
    cl += ' btn--small-with-title';
    hasTitle = true;
  }

  if (props.btnSmall) {
    cl += ' btn--small';
    jsxTitle = null;
    hasTitle = false;
  }

  if (hasIcon && hasTitle) {
    cl += ' btn--icon-and-title';
  }

  // dd_dusan dodao
  if (props.btnMedium) {
    cl += ' btn--medium';
  }
  if (props.btnMediumWidth) {
    cl += ' btn--medium-width';
  }


  if (props.btnColor) {
    cl += ' ' + props.btnColor;
  }

  let style = {};
  if (props.minWidth > 0) {
    style = {
      minWidth: props.minWidth
    };
  }

  if (props.btnHazard === true) {
    // HAZARD BTN
    return (
      <div
        className={cl + " btn--hazard"}
        onClick={handleClick}
        style={style}
      >
        <div className="btn--hazard__bg">
          <div className="btn--hazard__inner">
            <abbr title={props.tooltip}>
              {jsxFontAwsome}
              {jsxTitle}
            </abbr>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={cl}
      onClick={handleClick}
      style={style}
    >
      <abbr title={props.tooltip}>
        {jsxFontAwsome}
        {jsxTitle}
      </abbr>
    </div>
  );
};

export default Btn;